import {Component, forwardRef, Input} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {BaseControlValueAccessor} from './BaseControlValueAccessor';

@Component({
  selector: 'app-custom-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  providers: [
    {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => CheckboxComponent), multi: true},
  ]
})
export class CheckboxComponent extends BaseControlValueAccessor<boolean> {

  rnd = Math.random().toString(10);

  @Input() disabled = false;

  checkBoxChanged() {
    this.value = !this.value;
    this.onChange(this.value);
  }

}
